import { LAMPORTS_PER_SOL } from "@solana/web3.js";

export const MIN_STAKE_ACCOUNT_BALANCE = 1; // 1 sol
export const DEFAULT_STAKE_RENT_EXEMPT = 2282880 / LAMPORTS_PER_SOL;
